export const HANDLE_CONTENT_WIDTH = 'HANDLE_CONTENT_WIDTH'
export const HANDLE_MENU_COLLAPSED = 'HANDLE_MENU_COLLAPSED'
export const HANDLE_MENU_HIDDEN = 'HANDLE_MENU_HIDDEN'
export const HANDLE_RTL = 'HANDLE_RTL'
